import { Component, OnInit } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-scope',
  standalone: true,
  imports: [
    CommonModule, // for ngIf, ngFor, ngStyle
    FormsModule, // for ngModel
    ReactiveFormsModule, // for formGroup, formControlName
  ],
  templateUrl: './scope.component.html',
  styleUrls: ['./scope.component.scss'],
})
export class ScopeComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  course: any;
  courseDetails: any;
  courseDuration: any;
  scopeCourse: any;
  salary: any;
  topCampus: any;
  scopeDetails: any;
  eligibility: any;

  showAdd = false;
  showEdit = false;
  id: any;

  scopeForm: UntypedFormGroup;

  miniSalary: any;
  maxSalary: any;
  fees: any;
  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    courseval: [{ type: 'required', message: 'Please enter course' }],
    scopeVal: [
      { type: 'required', message: 'Please enter scope of the course' },
    ],
    durationVal: [
      { type: 'required', message: 'Please enter course duration' },
    ],
    eligibilityVal: [{ type: 'required', message: 'Please enter eligibility' }],
    miniFeesVal: [{ type: 'required', message: 'Please enter fees' }],
    // 'maxFeesVal': [
    //   { type: 'required', message: 'Please enter maximum fees' },
    // ],
    miniSalaryVal: [
      { type: 'required', message: 'Please enter minimum salary' },
    ],
    maxSalaryVal: [
      { type: 'required', message: 'Please enter maximum salary' },
    ],
    topCampusVal: [{ type: 'required', message: 'Please enter top campuses' }],
  };
  adminName: any;
  adminImage: any;
  allScope: any;
  allData: any;

  showData = false;
  showNodata = false;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.scopeForm = this.formBuilder.group({
      courseval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      // degreeTypeVal: new FormControl('', Validators.compose([
      //   Validators.required,
      // ])),
      // courseTypeVal: new FormControl('', Validators.compose([
      //   Validators.required,
      // ])),
      scopeVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      durationVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      eligibilityVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      miniFeesVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      // maxFeesVal: new FormControl('', Validators.compose([
      //   Validators.required,
      // ])),
      miniSalaryVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      maxSalaryVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      topCampusVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.scopeForm.reset();
    // GET ALL COURSE DETAILS \\
    const servicePath = this.utils.getApiConfigs('coursedetails');
    this.commonservice
      .invokeService(servicePath[1].method, servicePath[1].path, '')
      .then((resp: any) => {
        // console.log("CourseDetails", resp);
        if (resp.status_code == '200') {
          this.courseDetails = resp.data;
        }
      });

    // GET ALL THE SCOPE \\
    this.spinner.show();
    const servicePathScope = this.utils.getApiConfigs('scope');
    this.commonservice
      .invokeService(servicePathScope[1].method, servicePathScope[1].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("Scope details", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.scopeDetails = resp.data;

          if (this.scopeDetails == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.allScope = this.scopeDetails;
      });
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.scopeDetails;

    // console.log("All Data", this.allData);

    if (val) {
      this.allScope = this.allData.filter(
        (item) =>
          item.courses.toLowerCase().includes(val.toLowerCase()) ||
          item.course_type.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allScope);
    if (this.allScope == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  openAdd() {
    this.scopeForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  deleteScope(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  editScope(data) {
    // console.log("Data", data);
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.id = data.id;
    this.course = data.course_details_id;
    this.scopeCourse = data.scope;
    this.courseDuration = data.durations;
    this.salary = data.salary;
    this.topCampus = data.top_campus;
    this.eligibility = data.eligibility;
  }

  addScope() {
    this.spinner.show();
    let payload = {
      course_details_id: this.course,
      scope: this.scopeCourse,
      duration: this.courseDuration,
      salary: this.salary,
      top_campus: this.topCampus,
      eligibility: this.eligibility,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('scope');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess(
            'Scope of the Course added Successfully'
          );
          this.display = 'none';
          this.ngOnInit();
          this.scopeForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  updateScope() {
    this.spinner.show();
    this.salary = this.miniSalary.concat(' - ', this.maxSalary.toString());

    // console.log("salary", this.salary);

    let payload = {
      id: this.id,
      course_details_id: this.course,
      scope: this.scopeCourse,
      durations: this.courseDuration,
      salary: this.salary,
      fees: this.fees,
      top_campus: this.topCampus,
      eligibility: this.eligibility,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('editscope');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess(
            'Scope of the Course updated Successfully'
          );
          this.display = 'none';
          this.ngOnInit();
          this.scopeForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.globalService.showError(resp.message);
          this.display = 'none';
        }
      });
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletescope');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess(
            'Scope of the Course deleted Successfully'
          );
          this.displayDelete = 'none';
          this.ngOnInit();
          this.scopeForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.showErr = true;
          this.deleteErr = resp.message;
          this.scopeForm.reset();
        }
      });
  }
}
